/**
 * Header search (desktop nav)
 * Collapses the nav search field to its magnifier icon and expands it on
 * click. Enhancement only: the collapse is gated on the `.js` root class,
 * so without JavaScript the field stays expanded and the plain GET form
 * keeps working.
 *
 * @package StandOut
 * @since 2.0.0
 */
import { $ } from "@utils/dom";
const OPEN_CLASS = "is-open";
export const initHeaderSearch = () => {
    const form = $(".header-search");
    const input = $(".header-search__input");
    const submit = $(".header-search__submit");
    if (!form || !input || !submit) {
        return;
    }
    // PHP renders is-open when a zoeken term is active, so the visitor sees
    // what the results are filtered on.
    submit.setAttribute("aria-expanded", String(form.classList.contains(OPEN_CLASS)));
    submit.setAttribute("aria-controls", input.id);
    const isOpen = () => form.classList.contains(OPEN_CLASS);
    const isEmpty = () => input.value.trim() === "";
    const setOpen = (open) => {
        form.classList.toggle(OPEN_CLASS, open);
        submit.setAttribute("aria-expanded", String(open));
    };
    submit.addEventListener("click", (event) => {
        if (!isOpen()) {
            event.preventDefault();
            setOpen(true);
            input.focus();
            return;
        }
        // Open with an empty field: the click closes instead of searching.
        if (isEmpty()) {
            event.preventDefault();
            setOpen(false);
        }
    });
    document.addEventListener("keydown", (event) => {
        // Cmd/Ctrl+K opens and focuses the search, palette-style. Only while
        // the nav search is rendered — below the nav seam it lives in the
        // drawer and a hidden input must not steal focus.
        if (event.key === "k" && (event.metaKey || event.ctrlKey) && form.offsetParent !== null) {
            event.preventDefault();
            setOpen(true);
            input.focus();
            input.select();
            return;
        }
        if (event.key === "Escape" &&
            isOpen() &&
            isEmpty() &&
            form.contains(document.activeElement)) {
            setOpen(false);
            submit.focus();
        }
    });
    document.addEventListener("click", (event) => {
        if (isOpen() && isEmpty() && event.target instanceof Node && !form.contains(event.target)) {
            setOpen(false);
        }
    });
};
